export default {
    methods: {
        findNextItem: function (siblings, needle) {
            let index = siblings.findIndex((el) => {
                return parseInt(el) === parseInt(needle)
            })
            if((index + 1) < siblings.length) return siblings[index + 1]
            if((index + 1) === siblings.length ) return siblings[0]
        },
        findPrevItem: function (siblings, needle) {
            let index = siblings.findIndex((el) => {
                return parseInt(el) === parseInt(needle)
            })
            if(index > 0) return siblings[index - 1]
            if(index === 0) return siblings[siblings.length - 1]
        },

        showTooltip: function(event) {
            if(this.isMobile()) return false;
            let item = event.currentTarget
            let title = item.getAttribute('data-title')
            let toolTip = document.getElementById('rkw-tooltip')
            let coords = item.getBoundingClientRect()

            if(item.getAttribute('data-active') === "1") return false;

            toolTip.style.top = (coords.top - 20) + 'px'
            toolTip.style.left = (coords.right + 20) + 'px'
            toolTip.innerHTML = title
            toolTip.className += ' c-rkw-tooltip--show'
            let color = item.getAttribute('data-color')
            if(color) {
                toolTip.className += ' c-rkw-tooltip' + color
            }
            let dir = item.getAttribute('data-dir')
            if(dir) {
                //toolTip.classList.add('c-rkw-tooltip' + dir)
            }
        },
        hideTooltip: function(event) {
            let toolTip = document.getElementById('rkw-tooltip')
            toolTip.style.top = '-1000px'
            toolTip.style.left = '-1000px'
            toolTip.className = 'c-rkw-tooltip'
        },
        moveMouse: function(event) {
            if(this.isMobile()) return false;
            let toolTip = document.getElementById('rkw-tooltip')
            toolTip.style.top = (event.pageY - 10) + 'px'
            toolTip.style.left = (event.pageX - 10) + 'px'
        },
        getBookmarkContent (uid) {
            return this.$store.state.data['instances'][uid]
        },
        toggleBookmarkModal () {
            this.$store.commit('toggleBookmarkModal')
        },
        addBookmark (uid, target, event) {
            this.whooshToElement(event.target, document.getElementsByClassName(target)[0])
            this.$store.commit('addBookmark', uid)
            //console.log(this.$store.state.runtime.bookmarks.entries)
        },
        removeBookmark (uid) {
            this.$store.commit('removeBookmark', uid)
        },
        getContentModel (uid) {
            let task = this.$store.state.data['tasks'][this.$store.state.data['instances'][uid]['parent']]
            let mechanism = this.$store.state.data['mechanisms'][task['parent']]
            return this.$store.state.data['models']['uid' + mechanism['parent']]
            //return this.$store.state.settings.colors[model['color']]
        },
        getContentColor (uid) {
            return this.getContentModel(uid)['color']
        },
        isBookmarked (uid) {
            let el = this.$store.state.runtime.bookmarks.entries.find(bookmark => parseInt(bookmark) === parseInt(uid))
            return (typeof el !== 'undefined')
        },
        toggleTutorial () {
            this.$store.commit('toggleTutorial')
        },
        whooshToElement(startEl, targetEl) {
            let startCoords = startEl.getBoundingClientRect()
            let targetCoords = targetEl.getBoundingClientRect()

            let container = document.getElementById('rkwDigiKit')

            let clone = startEl.cloneNode(true)
            clone.addEventListener("transitionend", function(event) {
                event.currentTarget.remove()
                //container.removeChild(event.currentTarget)
            }, false)
            clone.style.top = startCoords.top + 'px'
            clone.style.left = startCoords.left + 'px'
            clone.className += ' whooshElement'
            container.appendChild(clone)

            window.setTimeout(function () {
                clone.style.top = targetCoords.top + 'px'
                clone.style.left = targetCoords.left + 'px'
                clone.style.opacity = 0
            }, 100)

        },
        isMobile () {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                return (window.innerWidth <= 1019 )
            } else {
                return false
            }
        },
        eTrackerLog (area, pageName, url) {
            let etrackerCode = '0M9AHV'
            if(url.lastIndexOf('/') !== url.length -1) {
                url = url + '/'
            }

            if(typeof _etracker === "object") {
                let data = {
                    'et_et': etrackerCode,
                    'et_areas': 'app.digitalisierungs-cockpit.de/' + area,
                    'et_pagename': 'https://app.digitalisierungs-cockpit.de/#' + url
                }
                console.log(data)
                et_eC_Wrapper(data)
            }
        },
        setActiveInstance (instanceId) {
            store.commit('setActiveInstance', instanceId)
            this.pushInstanceRoute(instanceId)
        },
        pushInstanceRoute (instanceId) {
            router.push({path: '/beispiel/' + this.getInstanceURI(instanceId)})
        },
        getInstanceURI (instanceId) {
            let instance = this.$store.state.data['instances'][instanceId]
            let title = ''
            if(typeof instance !== 'undefined' && instance !== null) {
                title = '-' + encodeURI(instance.content.header.replace(/\s+|\//gi, '-'))
            }
            return instanceId + title
        }
    }
}


// WEBPACK FOOTER //
// ./source/vuejs/mixins.js